import React, { useRef } from 'react';

/** Wraps a CTA so it leans toward the mouse and springs back (no effect on touch). */
export default function Magnetic({ children, strength = 0.28, className = '' }) {
  const ref = useRef(null);
  return (
    <span
      ref={ref}
      className={`pnp-magnetic ${className}`.trim()}
      onPointerMove={(e) => {
        if (e.pointerType !== 'mouse') return;
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2);
        const dy = e.clientY - (r.top + r.height / 2);
        el.style.transitionDuration = '150ms';
        el.style.transform = `translate(${dx * strength}px, ${dy * strength}px)`;
      }}
      onPointerLeave={() => {
        const el = ref.current;
        if (!el) return;
        el.style.transitionDuration = '600ms';
        el.style.transform = 'translate(0, 0)';
      }}
    >
      {children}
    </span>
  );
}
